// extracted by mini-css-extract-plugin
module.exports = {"item":"FL0RI"};